<template>
    <div :key="updateKey" class="catalogues-modal-outer-container-xs">
        <div class="catalogues-modal-empty-container-xs" @click="$emit('close-modal')"></div>
        <transition
            appear
            enter-active-class="animate__animated animate__slideInUp"
            leave-active-class="animate__animated animate__slideOutDown"
        >
            <div class="catalogues-modal-inner-container-xs">
                <div class="position-relative mt-4">
                    <p class="fsz-20 primary-color mb-0 fw-bold text-center">Catalogues</p>
                    <div class="catalogues-modal-close-btn-xs" @click="$emit('close-modal')">
                        <img src="../assets/close-modal-icon.svg" alt="" />
                    </div>
                </div>
                <section class="catalogues-modal-slider-titles-container-xs">
                    <div class="w-100 position-absolute d-flex justify-content-between">
                        <div class="catalogues-modal-slider-titles-side-boxes-xs"></div>

                        <div class="catalogues-modal-slider-titles-side-boxes-xs"></div>
                    </div>
                    <div
                        class="w-100 h-100 position-absolute d-flex justify-content-between align-items-center px-1 left-0"
                    >
                        <img src="../assets/preview-arrow.svg" alt="" @click="prevCategory" />
                        <img src="../assets/next-arrow.svg" alt="" @click="nextCategory" />
                    </div>

                    <div class="catalogues-modal-slider-titles-text-xs">
                        <p class="third-color fsz-12 justify-content-end">
                            {{ advancedModeCatalogs[prevTitleIndex].name }}
                        </p>
                        <p class="accent-color fsz-14 fw-bold justify-content-center">
                            {{ advancedModeCatalogs[activeTitleIndex].name }}
                        </p>
                        <p class="third-color fsz-12 justify-content-start">
                            {{ advancedModeCatalogs[nextTitleIndex].name }}
                        </p>
                    </div>
                </section>
                <section :key="updateKey" class="catalogues-modal-active-catalogue-container-xs">
                    <div
                        :class="[
                            checkIncluded(catalogueImages[activeSlideIndex].id) === 'active'
                                ? 'catalogues-modal-active-catalogue-checkbox-active-xs'
                                : 'catalogues-modal-active-catalogue-checkbox-inactive-xs',
                        ]"
                        @click="selecteCatalogue(catalogueImages[activeSlideIndex])"
                    ></div>

                    <div
                        :class="[
                            checkIncluded(catalogueImages[activeSlideIndex].id) === 'active'
                                ? 'catalogues-modal-active-catalogue-accent-layer-active-xs'
                                : 'catalogues-modal-active-catalogue-accent-layer-inactive-xs',
                        ]"
                    ></div>
                    <div class="catalogues-modal-active-catalogue-image-container-xs">
                        <img
                            :src="catalogueSrc(activeSlideIndex)"
                            alt=""
                            width="100%"
                            height="180"
                        />
                    </div>
                    <div
                        class="w-100 h-100 position-absolute left-0 top-0 d-flex justify-content-between align-items-center px-3"
                    >
                        <div
                            class="catalogues-modal-active-catalogue-button-container-xs"
                            @click="prevImage"
                        >
                            <img src="../assets/preview-arrow.svg" alt="" />
                        </div>
                        <div
                            class="catalogues-modal-active-catalogue-button-container-xs"
                            @click="nextImage"
                        >
                            <img src="../assets/next-arrow.svg" alt="" />
                        </div>
                    </div>
                    <div class="catalogues-modal-active-catalogue-title-xs">
                        {{ catalogueName }}
                    </div>
                </section>

                <section class="catalogues-modal-all-images-container-xs">
                    <div
                        v-for="(image, idx) in catalogueImages"
                        :key="idx"
                        class="catalogues-modal-all-images-item-container-xs"
                        @click="changeActiveCatalogue(idx)"
                    >
                        <img
                            :src="imageSrc(image.src)"
                            alt=""
                            height="72px"
                            class="catalogues-modal-all-images-item-active-xs"
                        />
                        <img
                            v-show="checkIncluded(image.id) === 'active'"
                            src="../assets/tick-checkbox.svg"
                            alt=""
                            class="position-absolute"
                            width="24"
                        />
                        <div
                            :class="[
                                checkIncluded(image.id) === 'active'
                                    ? 'catalogues-modal-all-images-item-accent-layer-xs'
                                    : 'opacity-0',
                            ]"
                        ></div>
                    </div>
                </section>
                <section class="catalogues-modal-dots-container-xs">
                    <div
                        v-for="(dot, index) in catalogueImages"
                        :key="index"
                        :class="[dotsClass(index)]"
                    ></div>
                </section>
            </div>
        </transition>

        <div class="catalogues-modal-notification-container-xs">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Notification from '@/components/snacks/index.vue';

export default {
    components: {
        Notification,
    },
    data() {
        return {
            showNotification: false,
            notificationMessage: '',
            notificationStatus: '',

            activeTitleIndex: 0,
            activeSlideIndex: 0,
            selectedSingleCataloguesLocal: [],
            selectedMultipleCataloguesLocal: [],
            updateKey: 0,
        };
    },
    computed: {
        ...mapState(['vsStore']),
        ...mapGetters([
            'advancedModeCatalogs',
            'selectedCataloguesId',
            'selectedSingleCatalogues',
            'activeMultipleIndex',
            'multipleCatalogueLocal',
        ]),
        lastIndex() {
            return this.advancedModeCatalogs.length - 1;
        },
        prevTitleIndex() {
            if (this.activeTitleIndex === 0) {
                return this.lastIndex;
            }

            return this.activeTitleIndex - 1;
        },
        nextTitleIndex() {
            if (this.activeTitleIndex === this.lastIndex) {
                return 0;
            }

            return this.activeTitleIndex + 1;
        },
        catalogueImages() {
            return this.advancedModeCatalogs[this.activeTitleIndex].catalog_images;
        },
        catalogueSrc() {
            return (index) =>
                `${process.env.VUE_APP_BASE_IMAGE_SRC}${this.catalogueImages[index].src}`;
        },
        imageSrc() {
            return (src) => {
                return `${process.env.VUE_APP_BASE_IMAGE_SRC}${src}`;
            };
        },
        catalogueName() {
            const catalogueName = this.catalogueImages[this.activeSlideIndex].name;

            return catalogueName !== null && catalogueName.length > 15
                ? `${catalogueName.substring(0, 15)}...`
                : catalogueName;
        },

        dotsClass() {
            return (index) => {
                if (index === this.activeSlideIndex) {
                    return 'catalogues-modal-dots-active-xs';
                }
                return 'catalogues-modal-dots-inactive-xs';
            };
        },
    },

    methods: {
        checkIncluded(id) {
            const { catalogueType, activeMultipleIndex, selectedMultipleCatalogues } = this.vsStore;
            let itemClass = '';
            if (catalogueType === 'single') {
                const [filteredCatalogue] = this.selectedSingleCatalogues.filter((item) => {
                    return item.id === id;
                });
                if (filteredCatalogue && !filteredCatalogue.delete) {
                    itemClass = 'active';
                } else {
                    itemClass = 'inactive';
                }
            } else {
                const multi = selectedMultipleCatalogues[activeMultipleIndex];

                const [filteredCatalogue] = multi.filter((item) => {
                    return item.id === id;
                });
                if (filteredCatalogue && !filteredCatalogue.delete) {
                    itemClass = 'active';
                } else {
                    itemClass = 'inactive';
                }
            }
            return itemClass;
        },
        checkboxClass() {
            const checkboxId = this.catalogueImages[this.activeSlideIndex].id;
            if (this.checkIncluded(checkboxId) === 'active') {
                return 'catalogues-modal-active-catalogue-checkbox-active-xs';
            } else {
                return 'catalogues-modal-active-catalogue-checkbox-inactive-xs';
            }
        },
        accentLayerClass() {
            const checkboxId = this.catalogueImages[this.activeSlideIndex].id;
            if (this.checkIncluded(checkboxId) === 'active') {
                return 'catalogues-modal-active-catalogue-accent-layer-active-xs';
            } else {
                return 'catalogues-modal-active-catalogue-accent-layer-inactive-xs';
            }
        },

        changeActiveCatalogue(index) {
            this.activeSlideIndex = index;
        },

        selecteCatalogue(catalogue) {
            this.updateKey++;
            const { catalogueType } = this.vsStore;
            if (catalogueType === 'single') {
                let singleData = {};
                singleData.catalogue = catalogue;
                this.$store.commit('handleSingleCataloguesXs', singleData);
            } else {
                let lengthOfSelected = this.multipleCatalogueLocal[this.activeMultipleIndex].length;
                if (lengthOfSelected > 2) {
                    this.showNotification = true;
                    this.notificationMessage = 'You cannot choose more than three catalogs!';
                    this.notificationStatus = 'warning';
                    return;
                }

                let multipleData = {};
                multipleData.catalogue = catalogue;
                this.$store.commit('handleMultipleCatalogues', multipleData);
                this.$store.commit('handleVSChanges', true);
            }
        },

        nextCategory() {
            if (this.activeTitleIndex < this.lastIndex) {
                this.activeTitleIndex++;

                return;
            }
            this.activeTitleIndex = 0;
        },
        prevCategory() {
            if (this.activeTitleIndex === 0) {
                this.activeTitleIndex = this.lastIndex;
                return;
            }
            this.activeTitleIndex--;
        },

        prevImage() {
            const lastIndexOfCatalogues = this.catalogueImages.length - 1;
            if (this.activeSlideIndex === 0) {
                this.activeSlideIndex = lastIndexOfCatalogues;
                return;
            }
            this.activeSlideIndex--;
        },
        nextImage() {
            const lastIndexOfCatalogues = this.catalogueImages.length - 1;
            if (this.activeSlideIndex < lastIndexOfCatalogues) {
                this.activeSlideIndex++;
                return;
            }
            this.activeSlideIndex = 0;
        },
    },
};
</script>

<style lang="scss" scoped>
img {
    border-radius: 8px;
    object-fit: cover;
    object-position: center;
}
.catalogues-modal {
    &-outer-container-xs {
        position: fixed;
        inset: 0;
        bottom: 0;
        background-color: rgba($color: #888, $alpha: 0.7);
        z-index: 100;
    }
    &-empty-container-xs {
        width: 100%;
        height: calc(100vh - 487px);
    }
    &-inner-container-xs {
        width: 100%;
        height: 487px;
        overflow-y: auto;
        position: absolute;
        bottom: 0;
        border-top-right-radius: 24px;
        border-top-left-radius: 24px;
        background-color: $Background-Color;
    }
    &-close-btn-xs {
        position: absolute;
        top: 0px;
        right: 24px;
    }
    &-slider-titles {
        &-container-xs {
            width: calc(100% - 40px);
            height: 52px;
            margin: 24px auto 0;
            margin-top: 24px;
            display: flex;
            position: relative;
        }
        &-side-boxes-xs {
            position: relative;
            display: flex;
            align-items: center;
            width: 20%;
            height: 52px;
            background: linear-gradient(
                0deg,
                #fcfcfc 3.53%,
                #fcfcfc 39.52%,
                rgba(252, 252, 252, 0.8) 50.9%,
                rgba(252, 252, 252, 0.2) 75.08%,
                rgba(252, 252, 252, 0) 96.75%
            );
        }
        &-text-xs {
            width: 100%;
            height: 52px;
            display: grid;
            grid-template-columns: repeat(3, calc((100% - 64px) / 3));
            column-gap: 32px;
            align-items: center;
            p {
                display: flex;
                align-items: center;
                height: 100%;
            }
        }
    }
    &-active-catalogue {
        &-container-xs {
            width: calc(100% - 40px);
            height: 180px;
            margin: 0 auto 24px;
            position: relative;
        }
        &-checkbox {
            &-container-xs {
                z-index: 2;
                width: 100%;
                height: 100%;
                position: absolute;
            }
            &-active-xs {
                width: 24px;
                height: 24px;
                border-radius: 4px;
                position: absolute;
                top: 16px;
                right: 16px;
                background-image: url('../assets/tick-checkbox.svg');
                background-position: center;
                background-size: contain;
                box-shadow: 0px 4px 5px rgba(24, 36, 133, 0.25);
                z-index: 50;
            }
            &-inactive-xs {
                width: 24px;
                height: 24px;
                position: absolute;
                top: 16px;
                right: 16px;
                background-color: #fff;
                border-radius: 8px;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
                z-index: 50;
            }
        }
        &-image {
            &-container-xs {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                img {
                    border-radius: 8px;
                    object-fit: cover;
                    object-position: center;
                }
            }
        }
        &-accent-layer {
            &-active-xs {
                width: 100%;
                height: 180px;
                position: absolute;
                top: 0;
                border-radius: 8px;
                background-color: rgba($color: $Accent-Overlay, $alpha: 0.5);
                z-index: 2;
                transition: background-color 0.7s;
            }
            &-inactive-xs {
                opacity: 0;
                transition: all 0.7s;
            }
        }
        &-button {
            &-container-xs {
                @include centerByFlex;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background-color: rgba($color: #fff, $alpha: 0.8);
                z-index: 20;
            }
        }
        &-title-xs {
            position: absolute;
            width: 100%;
            height: 36px;
            line-height: 36px;
            bottom: 0;
            padding: 0 0 8px 8px;
            color: #fff;
            font-weight: bold;
            font-size: 14px;
            border-radius: 0 0 8px 8px;
            background: linear-gradient(
                360deg,
                #000000 0%,
                rgba(0, 0, 0, 0.52) 71.35%,
                rgba(0, 0, 0, 0) 100%
            );
            opacity: 0.88;
        }
    }
    &-all-images {
        &-container-xs {
            display: flex;
            padding-top: 10px;
            padding-bottom: 10px;
            overflow-x: auto;
        }
        &-item {
            &-container-xs {
                @include centerByFlex;
                position: relative;
                width: 50%;
                margin-right: 8px;
            }
            &-accent-layer-xs {
                width: 100%;
                height: 72px;
                position: absolute;
                top: 0;
                border-radius: 8px;
                background-color: rgba($color: $Accent-Overlay, $alpha: 0.5);
                z-index: 2;
                transition: background-color 0.7s;
            }
        }
    }
    &-dots {
        &-container-xs {
            width: 100%;
            height: 6px;
            margin-top: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 8px;
        }
        &-active-xs {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: $Primary-Text-Color;
            box-shadow: $Black-Shadow;
            transition: all 0.7s;
        }
        &-inactive-xs {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: $Primary-Text-Color;
            box-shadow: $Black-Shadow;
        }
    }
    &-notification {
        &-container-xs {
            width: 330px;
            position: fixed;
            bottom: 20px;
            right: 10px;
        }
    }
}
</style>
